import { useQuery } from "@tanstack/react-query";
import { getAllAcademicTerms } from "../../api/apiAcademicTerms";
import i18next from "i18next";

export function useGetAcademicTerms(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["academicTerms", page, perPage, filters, i18next.language],
        queryFn: () => getAllAcademicTerms(page, perPage, filters),
        retry: false,
    });

    const academicTerms = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };

    return { isLoading, error, academicTerms, meta };
}
